// extracted by mini-css-extract-plugin
export default {"error_block":"_3EcUCc9K","error_body":"_2Xn-2VAg","error_heading":"-hAIPcuA"};